var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MessageType } from './Model';
import { action, computed, observable } from 'mobx';
import Theme from 'Theme';
import History from 'helpers/History';
export default class default_1 {
    constructor() {
        this.loading = [];
        this.message = undefined;
        this.catalogViewTypeLeft = CatalogViewType.Cell;
        this.catalogViewType = CatalogViewType.Cell;
        this.isDesktop = false;
        this.constructString = (data) => {
            let route = data.url
                .slice(data.baseURL.length)
                .replace(/^([a-z\/]+).*$/, '$1')
                .replace(/\/$/, '');
            let result = data.method + '@' + route;
            return result;
        };
        this.createLoading = (data) => {
            this.loading.push(this.constructString(data));
        };
        this.removeLoading = (data) => {
            if (!data)
                this.loading = [];
            else {
                let index = this.loading.indexOf(this.constructString(data));
                if (index > -1) {
                    this.loading.splice(index, 1);
                }
            }
        };
        this.isLoading = (request) => {
            if (!request)
                return false;
            let requests = Array.isArray(request) ? request : [request];
            return this.loading.some((e) => requests.includes(e));
        };
        this.setViewType = (catalogViewType) => {
            // console.error('UI - setViewType')
            this.catalogViewType = catalogViewType;
        };
        this.setViewTypeLeft = (value) => {
            console.log('UI - setViewTypeLeft - value: ', value);
            this.catalogViewTypeLeft = value;
        };
        this.changeMenuSelected = (nuevo) => {
            this.menuSelected = nuevo;
            this.menuSelectedConfiguracion = '';
        };
        this.changeMenuSelectedConfiguracion = (nuevo) => {
            this.menuSelectedConfiguracion = nuevo;
        };
        this.changeMenuSelectedOperaciones = (nuevo) => {
            this.menuSelectedOperaciones = nuevo;
        };
        this.setMessage = (text, type, noTop) => {
            if (type && text) {
                this.message = { text, type, noTop };
                this.hideMessage();
            }
            else
                this.message = undefined;
        };
        this.setIsDesktop = () => {
            this.isDesktop =
                /*!this.isMobileDevice()*/
                window.innerWidth >= Theme.common.devices.desktopWidth &&
                    window.innerHeight >= Theme.common.devices.mobileHeight;
        };
        this.changeHasParent = (value) => {
            // console.log('UI/Store - changeHasParent - History.location: ', History.location)
            this._hasParent = value;
        };
        this.hideMessage = () => {
            setTimeout(() => {
                this.setMessage();
            }, 3000);
        };
        // window.addEventListener('resize', this.setIsDesktop)
        this.setIsDesktop();
    }
    newOk(text, noTop = false) {
        this.setMessage(text, MessageType.Ok, noTop);
    }
    newWarning(text, noTop) {
        this.setMessage(text, MessageType.Warning, noTop);
    }
    newError(text, noTop) {
        this.setMessage(text, MessageType.Error, noTop);
    }
    get hasParent() {
        // console.log('UI/Store - hasParent - _hasParent: ', this._hasParent)
        // console.log('UI/Store - hasParent - History.location: ', History.location)
        // console.log('UI/Store - hasParent -  (History.location.pathname.match(/\\//g) || []).length >= 2: ',  (History.location.pathname.match(/\//g) || []).length >= 2)
        return (this._hasParent ||
            (History.location.pathname.match(/\//g) || []).length >= 2);
    }
    isMobileDevice() {
        return (typeof window.orientation !== 'undefined' ||
            navigator.userAgent.indexOf('IEMobile') !== -1);
    }
}
__decorate([
    observable
], default_1.prototype, "loading", void 0);
__decorate([
    observable
], default_1.prototype, "message", void 0);
__decorate([
    observable
], default_1.prototype, "catalogViewTypeLeft", void 0);
__decorate([
    observable
], default_1.prototype, "stretchSelected", void 0);
__decorate([
    observable
], default_1.prototype, "catalogViewType", void 0);
__decorate([
    observable
], default_1.prototype, "isDesktop", void 0);
__decorate([
    observable
], default_1.prototype, "menuSelected", void 0);
__decorate([
    observable
], default_1.prototype, "menuSelectedConfiguracion", void 0);
__decorate([
    observable
], default_1.prototype, "menuSelectedOperaciones", void 0);
__decorate([
    observable
], default_1.prototype, "_hasParent", void 0);
__decorate([
    action
], default_1.prototype, "createLoading", void 0);
__decorate([
    action
], default_1.prototype, "removeLoading", void 0);
__decorate([
    action
], default_1.prototype, "setViewType", void 0);
__decorate([
    action
], default_1.prototype, "setViewTypeLeft", void 0);
__decorate([
    action
], default_1.prototype, "changeMenuSelected", void 0);
__decorate([
    action
], default_1.prototype, "changeMenuSelectedConfiguracion", void 0);
__decorate([
    action
], default_1.prototype, "changeMenuSelectedOperaciones", void 0);
__decorate([
    action
], default_1.prototype, "setMessage", void 0);
__decorate([
    action
], default_1.prototype, "setIsDesktop", void 0);
__decorate([
    action
], default_1.prototype, "changeHasParent", void 0);
__decorate([
    computed
], default_1.prototype, "hasParent", null);
export const CatalogViewType = {
    Cell: 'cell',
    Row: 'row',
    Line: 'line',
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/UI/Store.ts
// module id = 91
// module chunks = 0